import CheckIcon from '@mui/icons-material/Check';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const SuccessNotification = (message: string) => {
  return (
    <Stack
      className="message-success"
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}>
      <CheckIcon />
      <Typography justifyContent="center">
        {message}
      </Typography>
    </Stack>
  )
};

export default SuccessNotification;